import React, { useRef, useState } from 'react'
import { Tabs, Swiper } from 'antd-mobile'
import { BodyView, TabsView } from "../factory/ViewUtil";

import AssetsFragmentController from './AssetsFragmentController';

const tabItems = [
  { key: '1', title: 'Coins' },
  { key: '2', title: 'Futures' },
  { key: '3', title: 'Second Futures' }
]

const AssetsViewController = (props) => {
    const swiperRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(localStorage.getItem('assetsTabIndex') || 0)
    
    const updateTab = (index) => {
        setActiveIndex(index)
        localStorage.setItem('assetsTabIndex', index)
    }

    return(
        <>
            <div className='fixed-nav-bar'>
                <div style={{
                        display : 'flex',
                        height : '52px',
                        alignItems : 'center',
                        borderLeft : '18px transparent solid',
                        borderRight : '18px transparent solid',
                        boxSizing : 'border-box',
                    }}>
                    <TabsView activeKey={tabItems[activeIndex].key}
                        onChange={key => {
                            const index = tabItems.findIndex(item => item.key === key)
                            updateTab(index)
                            swiperRef.current?.swipeTo(index)
                    }}>
                        {tabItems.map(item => (
                            <Tabs.Tab title={item.title} key={item.key} />
                        ))}
                    </TabsView>
                </div>
            </div>
            
            <BodyView content={{style : {'border' : 'none'}}} style={{paddingTop : '52px', paddingBottom : '50px'}}>
                <Swiper direction='horizontal' indicator={() => null}
                    ref={swiperRef}
                    defaultIndex={activeIndex}
                    onIndexChange={index => {
                        updateTab(index)
                    }}
                    style={{ height : '100%'}}
                    >
                        {/* <Swiper.Item><AssetsCoinsViewController {...props} /></Swiper.Item>
                        <Swiper.Item> <AssetsFuturesViewController {...props}/></Swiper.Item>
                        <Swiper.Item><AssetsSFViewController {...props}/></Swiper.Item> */}
                        <Swiper.Item><AssetsFragmentController type='1' {...props}/></Swiper.Item>
                        <Swiper.Item><AssetsFragmentController type='2' {...props}/></Swiper.Item>
                        <Swiper.Item><AssetsFragmentController type='3' {...props}/></Swiper.Item>
                </Swiper>
            </BodyView>
        </>
    );
}
export default React.memo(AssetsViewController)